import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { getRouter } from "./router";
import "./styles.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.2,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    // El registro del Service Worker (vite-plugin-pwa) puede fallar en ciertos browsers
    // o extensiones. No afecta la funcionalidad de la app — se descarta silenciosamente.
    const frames = event.exception?.values?.flatMap((v) => v.stacktrace?.frames ?? []) ?? [];
    if (frames.some((f) => f.filename?.includes("registerSW"))) return null;
    return event;
  },
});

const router = getRouter();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
          <h2>Algo salió mal</h2>
          <p>El error fue reportado automáticamente.</p>
          <pre style={{ fontSize: "0.8rem", color: "#888" }}>
            {String(error)}
          </pre>
          <button onClick={() => window.location.reload()}>
            Reintentar
          </button>
        </div>
      )}
    >
      <QueryClientProvider client={(router.options.context as any).queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
